import { getDeliveryFree } from '@/src/constants/delivery';
import { Typography as FenixTypography } from '@pedidosya/web-fenix/atoms';
import Fleet from '@pedidosya/web-fenix/icons/Fleet';
import {
  occasionTypes,
  deliveryFeeVariants as variants,
} from '@utils/constants';
import { translate } from '@utils/translate/translate';
import styled from 'styled-components';
import { PeyaPlusChip, Row, TextSeparator } from '../styles/styles';
import { vendorItem } from '../styles/vendorItem';

export const Typography = styled(FenixTypography)`
  &.original-fee {
    align-self: center;
    margin-left: ${({ theme }) => theme.space('spacing-component-small')};
  }
`;

const a11yLabels = translate.ARG_UY.vendorItem;
const textProps = vendorItem.properties.fonts;

const renderDeliveryFee = (
  deliveryFee,
  deliveryFeeWithDiscount,
  variant,
  countryId,
) => {
  const deliveryFeeVariants = {
    [variants.default]: () => (
      <Typography
        color={textProps.feeDefault.textColor}
        token={textProps.feeDefault.typography}
      >
        Envío {deliveryFee}
      </Typography>
    ),
    [variants.free]: () => (
      <Typography
        color={textProps.feeFree.textColor}
        token={textProps.feeFree.typography}
      >
        {getDeliveryFree(countryId)}
      </Typography>
    ),
    [variants.variable]: () => (
      <Typography
        color={textProps.feeVariable.textColor}
        token={textProps.feeVariable.typography}
      >
        Envío variable
      </Typography>
    ),
    [variants['plus-free']]: () => (
      <>
        <PeyaPlusChip
          aria-label={a11yLabels.shipping['plus-free']}
          viewBox="0 0 36 14"
        />
        <Typography
          color={textProps.feePlusFree.textColor}
          token={textProps.feePlusFree.typography}
        >
          {getDeliveryFree(countryId)}
        </Typography>
      </>
    ),
    [variants['plus-discount']]: () => (
      <>
        <PeyaPlusChip
          aria-label={a11yLabels.shipping['plus-discount']}
          viewBox="0 0 36 14"
        />
        <Typography
          color={textProps.feePlusDiscount.textColor}
          token={textProps.feePlusDiscount.typography}
        >
          Envío {deliveryFeeWithDiscount}
        </Typography>
        <Typography
          className="original-fee"
          color={textProps.originalFee.textColor}
          token={textProps.originalFee.typography}
        >
          {deliveryFee}
        </Typography>
      </>
    ),
  };

  return deliveryFeeVariants[variant]?.() || null;
};

export const ShippingInfoRow = ({
  occasion,
  deliveryTime,
  pickupTime,
  deliveryFee,
  deliveryFeeWithDiscount,
  deliveryETAVariant,
  deliveryFeeVariant,
  distance,
  hasSurgeFee,
  countryId,
}) => (
  <Row
    paddingTop="spacing-component-xsmall"
    paddingBottom="spacing-component-xsmall"
    color={textProps.feeDefault.textColor}
    token={textProps.feeDefault.typography}
  >
    {occasion.toLowerCase() === occasionTypes.delivery && (
      /* eslint-disable no-unsafe-optional-chaining */
      <>
        <Typography
          aria-label={a11yLabels.ETA[deliveryETAVariant]}
          color={
            textProps[
              `eta${
                deliveryETAVariant
                  ? deliveryETAVariant.charAt(0).toUpperCase() +
                    deliveryETAVariant.slice(1)
                  : ''
              }`
            ].textColor
          }
          token={
            textProps[
              `eta${
                deliveryETAVariant
                  ? deliveryETAVariant.charAt(0).toUpperCase() +
                    deliveryETAVariant.slice(1)
                  : ''
              }`
            ].typography
          }
        >
          {deliveryTime}
        </Typography>
        <TextSeparator>·</TextSeparator>
        {renderDeliveryFee(
          deliveryFee,
          deliveryFeeWithDiscount,
          deliveryFeeVariant,
          countryId,
        )}
        {hasSurgeFee && (
          <Fleet size="small" color={textProps.feeDefault.textColor} />
        )}
      </>
      /* eslint-enable no-unsafe-optional-chaining */
    )}
    {occasion.toLowerCase() === occasionTypes.pickup && (
      <>
        <Typography token={textProps.feeDefault.typography}>
          {pickupTime}
        </Typography>
        {!!pickupTime && !!distance && <TextSeparator>·</TextSeparator>}
        <Typography token={textProps.feeDefault.typography}>
          {distance}
        </Typography>
      </>
    )}
  </Row>
);
